//
// # FadeIn
//
// Plays the `.ide-fade-in` CSS animation once when mounted, then removes
// the class so that later DOM re-attachments (e.g. when dockview moves
// the panel on tab switch) don't replay the animation.
//
// The animation runs on initial expand and whenever the wrapper is
// freshly mounted (i.e. the parent just started rendering it), but not
// on the transient DOM detach/reattach that dockview performs during
// tab switches.
//
// The inner structure must be a single `<div>` child (which the caller
// provides) — that div is the grid item whose `overflow: hidden` lets
// the `grid-template-rows: 0fr -> 1fr` animation collapse cleanly.
//

import React, { useEffect, useRef } from "react";

// Matches the CSS animation durations in ide.css (`.ide-fade-in`).
const FADE_IN_DURATION_MS = 200;

export function FadeIn({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const t = window.setTimeout(() => {
      el.classList.remove("ide-fade-in");
    }, FADE_IN_DURATION_MS);
    return () => window.clearTimeout(t);
  }, []);
  return (
    <div ref={ref} className="ide-fade-in">
      {children}
    </div>
  );
}
